import React, { useState, useEffect,Component } from "react";
import {Text, View, Image,TouchableOpacity } from "react-native";
import imageInfoTip from "../../assets/images/info.png";
import styles from '../styles/customToolTipStyles';
class CustomInfoTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfoModel : false,
    };
  }

  onMouseEnter = () => {
    this.setState({
      showInfoModel : true,
    })
  }

  onMouseLeave = () => {
    this.setState({
      showInfoModel : false,
    })
  }

  onPressInfoTip = () => {
    const {showInfoModel} = this.state;

    this.setState({
      showInfoModel : !showInfoModel,
    })
  }

  render() {
    const {showInfoModel} = this.state;
    return (
    <View style={styles.mainContainer}>
     { showInfoModel &&  
      <TouchableOpacity
      activeOpacity={1}
      onPress={()=> this.onMouseLeave()}
      style={styles.infoView}>
        <View style={styles.infoViewChild}>
          <Text  style={[styles.popUpTxt]}>
           {this.props.textToShow}
          </Text>
        </View>
        <View style={styles.triangleCss}></View>

      </TouchableOpacity> }
      <TouchableOpacity onPress={()=>this.onPressInfoTip()} style={styles.imageView}>
      <Image  onMouseLeave= {()=> this.onMouseLeave()} onMouseEnter={()=> this.onMouseEnter()} style={styles.imageInfoTip} source={imageInfoTip} />
    </TouchableOpacity>
    </View>
  );
     }
};



export default CustomInfoTip;
